import React from "react"

import { CloudIcon } from "@heroicons/react/24/outline"

import { Color, Size } from "~tailwindui/types/enums"

import { Button } from "~tailwindui/Basics"

import TimeProtectedLink from "components/TimeProtectedLink"

type CloudroomButtonProps = {
  href: string
  startsAt: string
  buttonSize?: Size
  strictMode?: boolean
  className?: string
  tailwind?: boolean
  text?: string
  compact?: boolean
  disabled?: boolean
}

const CloudroomButton: React.FC<CloudroomButtonProps> = ({
  href,
  text = "Cloud Room",
  compact = false,
  disabled = false,
  buttonSize,
  ...rest
}) => {
  return (
    <TimeProtectedLink href={href} {...rest}>
      {compact ? (
        <Button
          color={Color.Sky}
          size={buttonSize}
          className="w-full"
          disabled={disabled}
        >
          <span>{text}</span>
          <CloudIcon className="h-6 w-6" />
        </Button>
      ) : (
        <button
          disabled={disabled}
          className="mb-2 flex h-28 cursor-pointer flex-col rounded-md border-2 border-solid border-sky-600 bg-transparent p-3 text-center text-sm text-sky-600 hover:opacity-50 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-sky-600 sm:text-base md:text-lg"
        >
          <span className="flex w-full items-center justify-center">
            <CloudIcon className="h-14 w-14" />
          </span>
          <div>{text}</div>
        </button>
      )}
    </TimeProtectedLink>
  )
}

export default CloudroomButton
